// enable cart button when conditions accepted
window.addEventListener('DOMContentLoaded', () => {
  const toCheckoutBtnEl = document.querySelector('.btn-to-checkout-container');
  const legalCheckbox = document.getElementById('checkbox-legal');
  if (legalCheckbox) {
    legalCheckbox.addEventListener('change', function() {
      if (this.checked) {
        toCheckoutBtnEl.classList.remove('is-disabled');
      } else {
        toCheckoutBtnEl.classList.add('is-disabled');
      }
    });
  }

  const codeForm = document.getElementById('code-submit-form');
  if (codeForm) {
    codeForm.addEventListener('submit', async event => {
      codeForm.getElementsByClassName('btn')[0].classList.add('is-loading');
      event.preventDefault();
      const responseRaw = await fetch(window.location.origin + '/hatchery/api/confirmcode', {
        method: 'POST',
        body: JSON.stringify({
          code: codeForm.querySelector('input[name="code"]').value,
          page: codeForm.querySelector('input[name="page"]').value,
        }),
      });
      const responseJSON = await responseRaw.json();
      if (responseJSON.success) {
        setTimeout(() => {
          codeForm.getElementsByClassName('btn')[0].classList.remove('is-loading');
        }, 5000);
        window.location = responseJSON.url;
      } else {
        codeForm.getElementsByClassName('form-field-code')[0].classList.add('is-error');
        codeForm.getElementsByClassName('btn')[0].classList.remove('is-loading');
      }
    });
  }
});
